import axios from './providers/aiAxios';

const aiService = {
    generateProgram(data) {
        return axios.post(`/ai/generateProgram`, data);
    },
    transformProgram(data) {
        return axios.post(`/ai/transformProgram`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    },
    // Generative Video API methods
    generateVideo(data) {
        return axios.post(`/api/genvid/generate`, data);
    },
    getVideoStatus(queueId) {
        return axios.get(`/api/genvid/status/${queueId}`);
    },
    getVideos(params = {}) {
        const queryParams = new URLSearchParams({
            limit: params.limit || 10,
            offset: params.offset || 0,
            ...(params.status && { status: params.status })
        });
        return axios.get(`/api/genvid/videos?${queryParams}`);
    }
}

export default aiService;
